module.exports = __webpack_public_path__ + "static/img/font-11.53d711fc.svg";